<template>
  <button
    type="button"
    :class="buttonClass"
    :disabled="disabled"
    :title="title"
    @click="$emit('click', $event)">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'IconCircleButton',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    tone: {
      type: String,
      default: 'glass'
    },
    size: {
      type: String,
      default: 'md'
    }
  },
  computed: {
    buttonClass() {
      const tones = {
        glass: 'bg-white/80 backdrop-blur-md text-slate-900',
        solid: 'bg-white text-slate-900',
        ghost: 'bg-transparent text-slate-600'
      };
      const sizes = {
        sm: 'w-8 h-8',
        md: 'w-10 h-10',
        lg: 'w-12 h-12'
      };

      return [
        'rounded-full flex items-center justify-center transition-colors disabled:opacity-50 disabled:cursor-not-allowed',
        tones[this.tone] || tones.glass,
        sizes[this.size] || sizes.md
      ].join(' ');
    }
  }
}
</script>
